import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Main from "../Layout/Main";
import { Helmet } from 'react-helmet';
import CoverImage from '../CoverImage';
import TextBlock from '../TextBlock/TextBlock';
import PressQuotes from '../PressQuotes/PressQuotes';
import PhotoGrid from '../PhotoGrid';
import LargeEditorial from '../LargeEditorial';
import SmallBoxes from '../SmallBoxes/SmallBoxes';
import ImageBlocks from '../ImageBlocks';
import Carousel from  '../Carousel/Carousel';
import EditorialPortrait from '../EditorialPortrait';

import './kitkat.scss';

const Kitkat = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query KitkatQuery {
      markdownRemark(frontmatter: { pageId: { eq: "kitkat-page" } }) {
        frontmatter {
          components {
            type
            id
            deeplink
            variant
            content {
              videoSlides {
                video {
                  src
                  loop
                  autoplay
                  controls
                  caption
                  poster
                }
              }
              gridImages {
                caption
                featured
                image {
                  childImageSharp {
                    fluid(maxWidth: 2048, quality: 80) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                  extension
                  publicURL
                }
              }
              video {
                src
                loop
                autoplay
                controls
                poster
              }
              copy {
                leader
                headline
                caption
                trailer
                quotes {
                  line
                  source
                  socialIcons {
                    icon
                  }
                }
                body {
                  line
                }
                subheads {
                  line
                }
                headlines {
                  line
                }
                scriptHeadline {
                  line
                }
                blocks {
                  headline
                  headlines {
                    line
                  }
                  headline2
                  headline3
                  bullets {
                    bullet
                  }
                  type
                  image
                  leader
                  body {
                    line
                  }
                  body2 {
                    line
                  }
                  icon {
                    childImageSharp {
                      fluid(maxWidth: 2048, quality: 80) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                    extension
                    publicURL
                  }
                }
              }
              logo {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const availComponents = {
    CoverImage,
    TextBlock,
    PressQuotes,
    PhotoGrid,
    LargeEditorial,
    SmallBoxes,
    ImageBlocks,
    Carousel,
    EditorialPortrait
  }

  const renderComponents = () => {
    const components = markdownRemark.frontmatter.components;
    let hydratedComponents = [];
    components.forEach((component, i) => {
      const ComponentRef = availComponents[component.type];
      const deeplinkId = component.deeplink ? component.id : '';
      hydratedComponents.push(<ComponentRef key={i} id={deeplinkId} variant={component.variant} {...component.content}/>)
    })
    return hydratedComponents
  }

  return (
    <Main>
      <Helmet>
        <body className="page kitkat-page" />
      </Helmet>
      {renderComponents()}
    </Main>
  );
}

export default Kitkat
